export default __webpack_public_path__ + "static/media/2ndtitle.10652b7e.png";